/*eslint-disable no-console */

let $console = {

    log () {},

    info () {},

    warn () {},

    error () {},

    time () {},

    timeEnd () {},

    group () {},

    groupEnd () {},

    trace () {},

    count () {},
}

if (process.env.NODE_ENV != 'production') {
    $console = {

        log: console.log,

        info: console.info,

        warn: console.warn,

        error: console.error,

        time: console.time,

        timeEnd: console.timeEnd,

        group: console.group,

        groupEnd: console.groupEnd,

        trace: console.trace,

        count: console.count,
    }
}

/*eslint-enable no-console */

export default $console